import { render, staticRenderFns } from "./IconSvgCart.vue?vue&type=template&id=6705d33a&scoped=true&"
import script from "./IconSvgCart.vue?vue&type=script&lang=js&"
export * from "./IconSvgCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6705d33a",
  null
  
)

export default component.exports